import type { IQService, IWindowService } from "angular";
import { module } from "angular";
import type { IImageService } from "App/Modules/Services";

export class ImageService implements IImageService {
    public static $inject: string[] = ["$q", "$window"];

    constructor(private readonly $q: IQService, private readonly $window: IWindowService) {}

    public forceImageReload(src: string): ng.IPromise<void> {
        const deferred = this.$q.defer<void>();
        const iframe = this.$window.document.createElement("iframe");

        let firstLoad = true;
        const loadCallback = () => {
            if (firstLoad) {
                firstLoad = false;
                iframe.contentWindow.location.reload(true);
            } else {
                if (iframe.parentNode) {
                    iframe.parentNode.removeChild(iframe);
                }
                deferred.resolve();
            }
        };

        iframe.style.display = "none";
        this.$window.parent.document.body.appendChild(iframe);
        iframe.addEventListener("load", loadCallback, false);
        iframe.addEventListener("error", loadCallback, false);
        const doc = iframe.contentWindow.document;
        doc.open();
        // eslint-disable-next-line prefer-template
        doc.write('<html><head><title></title></head><body><img src="' + src + '"></body></html>');
        doc.close();
        return deferred.promise;
    }
}

module("mmServices").service("mmImageService", ImageService);
